import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContactFormV2Component } from '../contact-form-v2/contact-form-v2.component';

@Component({
  selector: 'app-contact-form-route',
  template: '',
  standalone: false
})
export class ContactFormRouteComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    const uid = this.resolveUid();
    ContactFormV2Component.open(this.dialog, uid ? { uid } : {})
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.router.navigate(['/contact']));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private resolveUid(): string | undefined {
    let snapshot = this.route.snapshot;
    while (snapshot) {
      const uid = snapshot.paramMap.get('contactUid') || snapshot.paramMap.get('id');
      if (uid) return uid;
      snapshot = snapshot.parent;
    }
    return undefined;
  }
}
